module.exports = __webpack_public_path__ + "static/img/pay_fail_joychat.7058e235.png";